module.exports = __webpack_public_path__ + "img/appelcake-met-banaan-en-yoghurt.57fbd445.jpg";